export const CREATE_OR_GET_USER_REQUEST = 'CREATE_OR_GET_USER_REQUEST';
export const CREATE_OR_GET_USER_SUCCESS = 'CREATE_OR_GET_USER_SUCCESS';
export const CREATE_OR_GET_USER_ERROR = 'CREATE_OR_GET_USER_ERROR';
export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_ERROR = 'FETCH_GROUPS_ERROR';
export const FETCH_GROUPS_FOR_USER_REQUEST = 'FETCH_GROUPS_FOR_USER_REQUEST'; 
export const FETCH_GROUPS_FOR_USER_SUCCESS = 'FETCH_GROUPS_FOR_USER_SUCCESS';
export const FETCH_GROUPS_FOR_USER_ERROR = 'FETCH_GROUPS_FOR_USER_ERROR';
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_ERROR = 'CREATE_GROUP_ERROR';
export const FETCH_INCIDENTS_REQUEST = 'FETCH_INCIDENTS_REQUEST';
export const UPDATE_INCIDENT_STATUS = 'UPDATE_INCIDENT_STATUS';
export const FETCH_INCIDENTS_SUCCESS = 'FETCH_INCIDENTS_SUCCESS';
export const FETCH_INCIDENTS_ERROR = 'FETCH_INCIDENTS_ERROR';
export const INVITE_GROUP_MEMBER_REQUEST = 'INVITE_GROUP_MEMBER_REQUEST';
export const INVITE_GROUP_MEMBER_SUCCESS = 'INVITE_GROUP_MEMBER_SUCCESS'; 
export const INVITE_GROUP_MEMBER_ERROR = 'INVITE_GROUP_MEMBER_ERROR'; 
export const UPDATE_CURRENTLY_SELECTED_REQUEST = 'UPDATE_CURRENTLY_SELECTED_REQUEST';
export const UPDATE_CURRENTLY_SELECTED_SUCCESS = 'UPDATE_CURRENTLY_SELECTED_SUCCESS';
export const UPDATE_CURRENTLY_SELECTED_ERROR = 'UPDATE_CURRENTLY_SELECTED_ERROR';
export const UPDATE_USER_PROFILE_SETTINGS_REQUEST = 'UPDATE_USER_PROFILE_SETTINGS_REQUEST';
export const UPDATE_USER_PROFILE_SETTINGS_SUCCESS = 'UPDATE_USER_PROFILE_SETTINGS_SUCCESS';
export const UPDATE_USER_PROFILE_SETTINGS_ERROR = 'UPDATE_USER_PROFILE_SETTINGS_ERROR';
export const BULK_USER_IMPORT_REQUEST = 'BULK_USER_IMPORT_REQUEST'
export const BULK_USER_IMPORT_SUCCESS = 'BULK_USER_IMPORT_SUCCESS'
export const BULK_USER_IMPORT_ERROR = 'BULK_USER_IMPORT_ERROR'
export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST' 
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS'
export const GET_USER_BY_ID_ERROR = 'GET_USER_BY_ID_ERROR'
export const FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST = "FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST"
export const FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS = "FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS"
export const FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR = "FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR"
